import { Router, NavigationEnd } from '@angular/router';
import { CountyService } from './services/county/county.service';
import { Component } from '@angular/core';
import { CommonService } from './services/common/common.service';
import { environment } from '../environments/environment';
declare const Stripe: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  loading: boolean = false;
  constructor(private _common: CommonService, private _county: CountyService, private router: Router) {
    this._common.loading.subscribe(res => this.loading = res);

  }
  ngAfterViewInit() {
    Stripe.setPublishableKey(environment.stripe_key);   
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts